import { render, staticRenderFns } from "./AddPriceLabeling.vue?vue&type=template&id=2fc0ce76&"
import script from "./AddPriceLabeling.vue?vue&type=script&lang=js&"
export * from "./AddPriceLabeling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports